import { IDisplayFieldModel, IDisplaySectionModel } from '../../interfaces/IDisplaySectionModel';

import { AccordionWrapper } from './AccordionWrapper';
import { CaseFileSection } from './CaseFileSection';
import { IUserModel } from '../../interfaces/IUser';
import { IValidation } from '../../interfaces/IError';
import { SectionRow } from './SectionRow';

interface IDynamicSectionRendererProps {
    displayAsCondensed: boolean;
    isOpen: boolean;
    numberOfColumns: number;
    parentKey?: string;
    rows: IDisplayFieldModel[][];
    section: IDisplaySectionModel;
    user: IUserModel;
    validation: IValidation;
}

export function DynamicSectionRenderer({
    displayAsCondensed,
    isOpen,
    numberOfColumns,
    parentKey,
    rows,
    section,
    user,
    validation,
}: IDynamicSectionRendererProps) {
    const hasRows = (rows?.length ?? 0) > 0;

    return (
        <>
            {hasRows && (
                <div>
                    {rows.map((fields, idx) => (
                        <SectionRow
                            key={idx}
                            fields={fields}
                            columnCount={numberOfColumns}
                            displayAsCondensed={displayAsCondensed}
                        />
                    ))}
                </div>
            )}
            {section.sections
                ?.sort((a, b) => (a.sortOrder < b.sortOrder ? -1 : 1))
                .map((nestedSection, idx) => {
                    const isLastSection = idx === section.sections?.length - 1;
                    const currentKey = `${parentKey ?? section.id}_${nestedSection.id}`;

                    return (
                        <div key={nestedSection.id} style={{ marginTop: hasRows ? 10 : 'auto' }}>
                            <AccordionWrapper
                                key={idx}
                                accordionIndex={currentKey}
                                isOpen={isOpen}
                                section={nestedSection}
                                shouldWrap={true}
                                isExpandable={true}
                                isLastSection={isLastSection}
                                isTopLevel={false}
                            >
                                <CaseFileSection
                                    displayAsCondensed={false}
                                    isOpen={isOpen}
                                    numberOfColumns={2}
                                    parentKey={currentKey}
                                    section={nestedSection}
                                    user={user}
                                    validation={validation}
                                />
                            </AccordionWrapper>
                        </div>
                    );
                })}
        </>
    );
}
